const socket = {
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
  },
  mutations: {
    SOCKET_ONOPEN: (state) => {
      state.socket.isConnected = true;
      console.log('SOCKET_ONOPEN');
    },
    SOCKET_ONCLOSE: (state) => {
      state.socket.isConnected = false;
      console.log('SOCKET_ONCLOSE');
    },
    SOCKET_ONERROR: (state) => {
      console.log('SOCKET_ONERROR');
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE: (state, message) => {
      state.message = message;
      console.log('ONMESSAGE');
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT: (state, count) => {
      console.info(state, count);
      console.log('SOCKET_RECONNECT');
    },
    SOCKET_RECONNECT_ERROR: (state) => {
      state.socket.reconnectError = true;
      console.log('SOCKET_RECONNECT_ERROR');
    },
  },
};

export default socket;



// WEBPACK FOOTER //
// ./src/store/modules/socket.js